import axios from 'axios'
import HTTP from './http'

export default {
    getClinicServices: payload => axios.get(HTTP.CLINIC_SERVICES, { params: payload }),
    list: payload => axios.get(HTTP.CLINIC_SERVICES_LIST, { params: payload }),
    addServiceClinics: payload => axios.post(HTTP.SERVICE_CLINIC, payload),
    deleteServiceClinics: payload => axios.delete(HTTP.SERVICE_CLINIC, { params: payload })
}
